import { Button } from '@mui/material';
import { purple } from '@mui/material/colors';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import UndoIcon from '@mui/icons-material/Undo';
import type { FC } from 'react';
import FormattedTooltip from './FormattedTooltip';

interface LLMToggleButtonProps {
  llmLoading: boolean;
  llmEnabled: boolean;
  handleLLMMagic: () => void;
}

const LLMToggleButton: FC<LLMToggleButtonProps> = ({ llmLoading, llmEnabled, handleLLMMagic }) => {
  return (
    <FormattedTooltip
      title={
        llmLoading ? 'Indlæser' : llmEnabled ? 'Deaktiver Auto-rettelse' : 'Anvend Auto-rettelse'
      }
      description={
        llmLoading
          ? 'Auto-rettelse behandler teksten...'
          : llmEnabled
            ? 'Gendanner den oprindelige tekst før Auto-rettelse blev anvendt'
            : 'Anvender AI til automatisk at rette og forbedre notens formatering og struktur'
      }
    >
      <Button
        variant="contained"
        color="secondary"
        onClick={handleLLMMagic}
        disabled={llmLoading}
        sx={{
          backgroundColor: purple[600],
          color: 'white',
          mx: 0.5,
          px: 1,
          minWidth: '32px',
          '& svg': {
            color: 'white !important',
          },
          '&:hover': {
            backgroundColor: purple[700],
            transform: 'scale(1.05)',
          },
          '&.Mui-disabled': {
            backgroundColor: purple[400],
            opacity: 0.6,
            '& svg': {
              color: 'white !important',
            },
          },
          transition: 'all 0.2s ease-in-out',
          boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        }}
      >
        {llmEnabled ? <UndoIcon fontSize="small" /> : <AutoAwesomeIcon fontSize="small" />}
      </Button>
    </FormattedTooltip>
  );
};

export default LLMToggleButton;
